import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/academy-ui/src/app/guides/view/[...guideIdAndStep]/GuideInformation.tsx");
